import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button } from 'common/ui/Button';
import { Colors } from 'styles';
import Text from 'common/ui/Text';

export type DeleteHPModalProps = {
  open: boolean;
  protocolName: string;
  onClose: () => void;
  onDelete: () => void;
};

export const DeleteHPModal = ({
  open,
  protocolName,
  onClose,
  onDelete,
}: DeleteHPModalProps): React.ReactElement => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        padding: '15px 16px 32px',
        backgroundColor: Colors.gray10,
        color: Colors.gray1,
      },
    }}
    data-testid="delete-hanging-protocol-form"
  >
    <DialogContent sx={{ width: 370 }} data-testid="delete-hanging-protocol-modal">
      <Text color="black">
        Are you sure you want to permanently delete &quot;{protocolName}&quot; hanging protocol?
      </Text>
    </DialogContent>
    <DialogActions>
      <Button variant="secondary" onClick={onClose} data-testid="cancel">
        <Text color="black">Cancel</Text>
      </Button>
      <Button
        type="submit"
        data-testid="delete-hanging-protocol-button"
        variant="error"
        onClick={onDelete}
      >
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);
